import { materialsListApi } from "./api";

export const getMaterials = async (params) => {
  try {
    const res = await materialsListApi.getMaterials(params);
    return res
  } catch (e) {}
};

export const getMaterialTypesFilter = async (params) => {
  try {
    const res = await materialsListApi.getMaterialTypesFilter(params);
    return res?.data;
  } catch (e) {}
};

export const getProvidersFilter = async (params) => {
  try {
    const res = await materialsListApi.getProvidersFilter(params);
    return res?.data;
  } catch (e) {}
};

export const getProviders = async () => {
  try {
    const res = await materialsListApi.getProviders();
    return res?.data;
  } catch (e) {}
};

export const updProvider = async (body, params) => {
  try {
    const res = await materialsListApi.updProvider(body, params);
    return res?.data;
  } catch (e) {}
};

export const updProviderPrice = async (body, params) => {
  try {
    const res = await materialsListApi.updProviderPrice(body, params);
    return res?.data;
  } catch (e) {}
};

export const getUnitsList = async () => {
  try {
    const res = await materialsListApi.getUnitsList();
    return res?.data;
  } catch (e) {}
};

export const getMaterialsList = async () => {
  try {
    const res = await materialsListApi.getMaterialsList();
    return res?.data;
  } catch (e) {}
};

export const getMaterialProvidersList = async (params) => {
  try {
    const res = await materialsListApi.getMaterialProvidersList(params);
    return res?.data;
  } catch (e) {}
};

export const getMaterialProviderPriceList = async (params) => {
  try {
    const res = await materialsListApi.getMaterialProviderPriceList(params);
    return res?.data;
  } catch (e) {}
};

export const updMaterial = async (body, params) => {
  try {
    const res = await materialsListApi.updMaterial(body, params);
    return res?.data;
  } catch (e) {}
};

export const deleteMaterialProvider = async (material_provider_id, params) => {
  try {
    const res = await materialsListApi.deleteMaterialProvider(material_provider_id, params);
    return res?.data;
  } catch (e) {}
};

export const deleteProviderPrice = async (material_priovider_price_id, params) => {
  try {
    const res = await materialsListApi.deleteProviderPrice(material_priovider_price_id, params);
    return res?.data;
  } catch (e) {}
};

export const deleteMaterial = async (material_id, params) => {
  try {
    const res = await materialsListApi.deleteMaterial(material_id, params);
    return res?.data;
  } catch (e) {}
};

export const getRequiredTypesFilter = async () => {
  try {
    const res = await materialsListApi.getRequiredTypesFilter();
    return res?.data;
  } catch (e) {}
};

export const getSbsNomenklaturaListForModal = async (search_text = "", kategoriya = null) => {
  try {
    const res = await materialsListApi.getSbsNomenklaturaListForModal(search_text, kategoriya);
    return res?.data || [];
  } catch (e) {
    console.error("Error loading SBS nomenklatura:", e);
    return [];
  }
};

export const getSbsNomenklaturaKategoriya = async () => {
  try {
    const res = await materialsListApi.getSbsNomenklaturaKategoriya();
    return res?.data || [];
  } catch (e) {
    console.error("Error loading SBS nomenklatura kategoriya:", e);
    return [];
  }
};

export const priceColumns = [
  {
    name: "rowversion",
    label: "Дата изменения",
    align: "center",
    field: "rowversion",
  },
  {
    name: "employee_fio",
    label: "Пользователь",
    align: "left",
    field: "employee_fio",
  },
  {
    name: "price_whole",
    label: "Период действия",
    align: "center",
    field: "price_whole",
    headerStyle: "width: 265px;",
    style: "width: 265px;",
  },
  {
    name: "old_price_whole",
    label: "Старая цена",
    align: "right",
    field: "old_price_whole",
  },
  {
    name: "new_price_whole",
    label: "Новая цена",
    align: "right",
    field: "new_price_whole",
  },
  {
    name: "price_diff_whole",
    label: "Изменение",
    field: "price_diff_whole",
    align: "center",
  },
  {
    name: "x",
    label: "",
    align: "center",
    field: "",
    headerStyle: "width: 55px;",
    style: "width: 55px;",
  },
];

export const providersColumns = [
  {
    name: "material_provider_id",
    label: "ID",
    align: "center",
    field: "material_provider_id",
    headerStyle: "width: 56px;",
    style: "width: 56px;",
  },
  {
    name: "provider_name",
    label: "Поставщик",
    align: "left",
    field: "provider_name",
    headerStyle: "width: 350px;",
    style: "width: 350px;",
  },
  {
    name: "provider_name",
    label: "Наименование материала у поставщика",
    align: "left",
    field: "provider_name",
    headerStyle: "width: 350px;",
    style: "width: 350px;",
  },
  {
    name: "price_whole",
    label: "Цена, ₸",
    align: "center",
    field: "price_whole",
    headerStyle: "width: 265px;",
    style: "width: 265px;",
  },
  {
    name: "date_begin",
    label: "Период",
    align: "center",
    field: "date_begin",
    headerStyle: "width: 250px;",
    style: "width: 250px;",
  },
  {
    name: "main_price",
    label: "Основная цена, ₸",
    align: "center",
    field: "main_price",
    headerStyle: "width: 120px;",
    style: "width: 120px;",
  },
  {
    name: "in_stock",
    label: "Наличие",
    align: "center",
    field: "in_stock",
    headerStyle: "width: 120px;",
    style: "width: 120px;",
  },
  {
    name: "actions",
    label: "Действие",
    align: "center",
    field: "actions",
    headerStyle: "width: 120px;",
    style: "width: 120px;",
  },
];

export const materialsCommonColumns = [
  {
    name: "id",
    required: true,
    label: "ID",
    align: "center",
    field: "id",
    headerStyle: "width: 56px;",
    style: "width: 56px;",
  },
  {
    name: "material_name",
    required: true,
    label: "Наименование",
    align: "left",
    field: "material_name",
    headerStyle: "width: 274px;",
    style: "width: 274px;",
  },
  {
    name: "material_type_name",
    required: true,
    label: "Тип материала",
    align: "left",
    field: "material_type_name",
    headerStyle: "width: 265px;",
    style: "width: 265px;",
  },
  {
    name: "ssylka__view",
    required: true,
    label: "Номенклатура 1С",
    align: "left",
    field: "ssylka__view",
    headerStyle: "width: 300px;",
    style: "width: 300px;",
  },
  {
    name: "provider_name",
    required: true,
    label: "Поставщик",
    align: "left",
    field: "provider_name",
    headerStyle: "width: 220px;",
    style: "width: 220px;",
  },
  {
    name: "price_whole",
    required: true,
    label: "Цена",
    align: "right",
    field: "price_whole",
    headerStyle: "width: 160px;",
    style: "width: 160px;",
  },
  {
    name: "consumption_unit",
    required: true,
    label: "Ед. расхода",
    align: "center",
    field: "consumption_unit",
    headerStyle: "width: 120px;",
    style: "width: 120px;",
  },
  {
    name: "actions",
    required: true,
    label: "Действия",
    align: "center",
    headerStyle: "width: 90px;",
    style: "width: 90px;",
  },
];
